// ** RTK Query Imports
import { createApi } from '@reduxjs/toolkit/query/react'

// ** Environment Variables
import { TAGS } from './tags'
import { baseQueryWithReauth } from './baseQueryWithReauth'

export const baseApi = createApi({
	baseQuery: baseQueryWithReauth,
	tagTypes: Object.values(TAGS),
	endpoints: () => ({})
})
